import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericOperationCaseModel } from 'app/modules/models/GenericOperationCaseModel.type';
import { GenericOperationCaseServicesModel } from 'app/modules/models/GenericOperationCaseServicesModel.type';
import { GenericFieldGeneratorProdcuts } from 'app/modules/models/genericFieldGenerator.type';
import { OperationModel } from 'app/modules/models/operation.type';
import { ParameterModel } from 'app/modules/models/parameter.type';
import { environment } from 'environments/environment';
import { map, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperationsService {

  protected apiRoute = environment.RESOURCE_API;
  protected teraApiRoute = environment.TERA_RESOURCE_API;

  private _selectedOperation: ReplaySubject<OperationModel> = new ReplaySubject<OperationModel>(1);

  get selectedOperation$(): Observable<OperationModel> {
    return this._selectedOperation.asObservable();
  }

  set selectedOperation(value: OperationModel) {
    this._selectedOperation.next(value);
  }

  constructor(private _http: HttpClient) { }

  getGenericOperations(): Observable<any[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.getGenericOperations;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as any[]))
  }

  getGenericOperationsCrm(): Observable<any[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.GetAllCrm + true + '/' + true;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as any[]))
  }

  getGenericOperationCases(genericFieldGeneratorProdcuts: GenericFieldGeneratorProdcuts, operationId: string): Observable<GenericOperationCaseModel[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.getCases + operationId;
    return this._http.post(route, genericFieldGeneratorProdcuts, this.prepareHeader()).pipe(map(res => res as GenericOperationCaseModel[]))
  }

  checkGenericOperationCaseServices(operationId: string, genericOerationCase: string, date: string) {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.checkAvailableServices + operationId + '/' + genericOerationCase + '/' + date;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as GenericOperationCaseServicesModel))
  }

  getBrandsByOperationId(operationId: number): Observable<ParameterModel[]> {
    const route = this.apiRoute + environment.apiCatalog.ficheOperation.subRoutes.getBrands + operationId;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as ParameterModel[]))
  }

  getGenericOperationsBalise(): Observable<OperationModel[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.getGenericOperationsBalise;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as OperationModel[]))
  }

  getGenericOperationsForValidationRules(): Observable<any[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.getAllActiveGenericOperations;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as any[]))
  }

  GetAllActiveWithBaliseForValidationRule(): Observable<any[]> {
    const route = this.teraApiRoute + environment.teraApiCatalog.genericOperation.controllerRoute + environment.teraApiCatalog.genericOperation.subRoutes.getAllActiveWithBalise;
    return this._http.get(route, this.prepareHeader()).pipe(map(res => res as any[]))
  }

  getAuthorizedByContract(partnerId: string, mandataireId: string, engagementDate: string): Observable<any[]> {
    const route = this.teraApiRoute +
      environment.teraApiCatalog.genericOperation.controllerRoute +
      environment.teraApiCatalog.genericOperation.subRoutes.getAuthorizedByContract +
      `${partnerId}?mandataireId=${mandataireId}&engagementDate=${encodeURIComponent(engagementDate)}`;

    return this._http.get(route, this.prepareHeader()).pipe(map((res: any) => res));
  }

  private prepareHeader(): Object {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return { headers: headers };
  }
}
